import { $, type Properties, resolve } from "signlets";

import {
  magneticToTrueDegrees,
  normalizeDegrees,
  trueToMagneticDegrees,
} from "../math";
import type { Position } from "../model";
import { NumberInput } from "./NumberInput";

export type DirectionInputProps = {
  direction: number;
  position: Position;
  onChangeDirection: (_: number) => void;
};

export const DirectionInput = ({
  direction,
  position,
  onChangeDirection,
}: Properties<DirectionInputProps>) => {
  const number = $(() =>
    normalizeDegrees(
      Math.round(trueToMagneticDegrees(resolve(direction), resolve(position))),
    ),
  );

  const onChangeNumber = (_: number) =>
    onChangeDirection(
      normalizeDegrees(Math.round(magneticToTrueDegrees(_, resolve(position)))),
    );

  return <NumberInput number={number} onChangeNumber={onChangeNumber} />;
};
